import { fetchWithTokenRefresh } from './AuthActions';
import { tags_returned, tag_received, tag_deleted, tag_updated } from './types';
import env from '../globals/environment';
import socket from '../globals/socket';

export const getTags = (refresh) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { tags } = state.tagsStore;

      socket.on('tag', tag => {
        dispatch({
          type: tag_received,
          payload: tag
        });
      });

      socket.on('tag-delete', id => {
        dispatch({
          type: tag_deleted,
          payload: id
        });
      });

      socket.on('tag-update', tag => {
        dispatch({
          type: tag_updated,
          payload: { _id: tag.id, name: tag.name }
        });
      });

      if (tags.length === 0 || refresh) {
        const { headers } = state.authStore;
        const response = await fetchWithTokenRefresh(`${env.backendUrl}/tags`, { headers })(dispatch);

        if (!response.ok) throw new Error('Could not get tags from api');
        else {
          const tags = await response.json();
          dispatch({
            type: tags_returned,
            payload: tags
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
};


// WEBPACK FOOTER //
// ./src/actions/TagsActions.js